<div class="product-category-responsive p-g-12">
   <div class="p-g-12">
      <p-tabView>
         <div class="p-g">

            <div class="p-g-12">
               <form>
                  <div class="p-g-12" class="p-toolbar-tecfolk-fix">
                     <p-toolbar>
                        <div class="p-g-12 p-toolbar-group-left productCategoryButton p-toolbar-tecfolk-fix">

                           <button routerLink="/product-categories" pButton type="button" [label]='setLabel("goBackBtnLabel")'
                              icon="pi pi-arrow-left"></button>
                           <button routerLink="/product" pButton type="button" style="background-color: #5192d0"
                              [label]='setLabel("newBtnLabel")' icon="pi pi-plus"></button>
                           <button id="saveCategory" pButton type="button" [disabled]="!addEditCategoryForm.valid"
                              (click)="save()" *ngIf="mode == 'add'" [label]='setLabel("saveBtnLabel")' icon="pi pi-plus"
                              class="p-button-success">
                           </button>
                           <button id="updateCategory" pButton type="button" [disabled]="!addEditCategoryForm.valid"
                              (click)="update()" *ngIf="mode == 'edit'" [label]='setLabel("updateBtnLabel")' icon="pi pi-save"
                              class="p-button-success">
                           </button>
                        </div>
                     </p-toolbar>
                  </div>

                  <p-tabView>

                     <div class="card card-w-title">

                        <div class="p-g-12">
                           <form #addEditCategoryForm="ngForm">
                              <div class="p-g-12 p-md-6">
                                 <div class="p-g p-fluid">
                                    <h3 class="first">{{setLabel("categoryDetailsLabel")}} </h3>
                                    <div class="p-g-12">
                                       <div class="p-inputgroup">
                                          <span style="font-size: 15px;" class="p-inputgroup-addon" [pTooltip]='setLabel("nameTooltipLabel")'
                                             tooltipPosition="top"><i class="fa fa-info" aria-hidden="true"></i></span>
                                          <input type="text" id="categoryName" #categoryName [placeholder]='setLabel("name*PlaceholderLabel")'
                                             name="name" [(ngModel)]="category.name"
                                             [ngClass]="CategoryName.invalid && (CategoryName.dirty || CategoryName.touched) ? 'errorInput' : '' "
                                             #CategoryName="ngModel" required>
                                       </div>
                                    </div>

                                    <div class="p-g-12">
                                       <div class="p-inputgroup">
                                          <span style="font-size: 15px;" class="p-inputgroup-addon"
                                             [pTooltip]='setLabel("descriptionTooltipLabel")' tooltipPosition="top"><i
                                                class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
                                          <textarea id="categoryDescription" rows="6" cols="67" name="description"
                                             [(ngModel)]="category.description" [placeholder]='setLabel("descriptionPlaceholderLabel")'></textarea>
                                       </div>
                                    </div>

                                 </div>
                              </div>
                           </form>

                        </div>

                        <div style="clear: both;"></div>
                     </div>

                  </p-tabView>
               </form>
            </div>
         </div>
      </p-tabView>
   </div>
</div>